import { Card, Stack, Typography, Box, useMediaQuery } from '@mui/material';
import { BankingInfoResponse } from '@/types/bankingInfo';
import { SVLink } from '@/components/core';

type AdvisorDashboardRateCardsProps = {
  bankingInfo: BankingInfoResponse;
};

export default function AdvisorDashboardRateCards({
  bankingInfo,
}: AdvisorDashboardRateCardsProps) {
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const {
    skyview1Apy,
    usNationalAverageApy,
    differenceSkyview1VsUsNationalAverage,
  } = bankingInfo.referenceInterestRates;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isLargeScreen ? 'row' : 'column',
        gap: 2,
        flex: 0,
        height: isLargeScreen ? '190px' : 'auto',
      }}>
      <Card>
        <Stack sx={{ textAlign: 'center' }}>
          <Typography fontWeight="bold" variant="body1">
            Current Rate (
            <Typography
              component="span"
              fontWeight="bold"
              variant="body1"
              color="primary.main">
              APY
            </Typography>
            )
          </Typography>
          <Typography sx={{ fontSize: '64px', fontWeight: 'bold' }}>
            {skyview1Apy}%
          </Typography>
          <Typography>
            <Typography color="success" fontWeight="bold" component="span">
              {differenceSkyview1VsUsNationalAverage}x
            </Typography>{' '}
            National Average
          </Typography>
        </Stack>
      </Card>
      <Card>
        <Stack sx={{ textAlign: 'center' }}>
          <Typography fontWeight="bold" variant="body1">
            National Average (
            <Typography
              component="span"
              fontWeight="bold"
              variant="body1"
              color="primary.main">
              APY
            </Typography>
            )
          </Typography>
          <Typography sx={{ fontSize: '64px', fontWeight: 'bold' }}>
            {usNationalAverageApy}%
          </Typography>
          {bankingInfo.indexFactSheetLink && (
            <SVLink target="_blank" to={bankingInfo.indexFactSheetLink}>
              Index Fact Sheet
            </SVLink>
          )}
        </Stack>
      </Card>
    </Box>
  );
}
